// components/TutorLayout.jsx
import React,{ useEffect } from "react";
import { Outlet } from "react-router-dom";
import TutorHeader from "../tutorpanel/TutorHeader";
import TutorFooter from "../tutorpanel/TutorFooter";
import TutorSidebar from "../tutorpanel/TutorSidebar";


const TutorLayout = () => {
   
  return (
    <div className="wrapper">
      <TutorSidebar />
      <div id="content">
        <TutorHeader />
              <Outlet />
        <TutorFooter />
      </div>
    </div>
  );
};

export default TutorLayout;
